import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon";
import type { File, LinkedRecordDisplayFormat } from "@smartsuite/types";
import cx from "classnames";
import React from "react";
import { FilePreview } from "../../../../../../../../components/Filestack/FilePreview/FilePreview";
import { getFileSizeByMode } from "./LinkedRecordCoverImage.helpers";

import "./LinkedRecordCoverImage.sass";

export type LinkedRecordCoverImageMode = LinkedRecordDisplayFormat | "record-item";

export interface LinkedRecordCoverImageProps {
  mode: LinkedRecordCoverImageMode;
  files: File[];
}

export const LinkedRecordCoverImage = ({
  mode,
  files = [],
}: LinkedRecordCoverImageProps): JSX.Element => {
  const currentFile = files[0];

  const classes = cx("linked-record-cover-image", `linked-record-cover-image--${mode}`, {
    "is-empty": !currentFile,
  });

  return (
    <div className={classes} aria-label="Linked Record Cover Image">
      {currentFile && (
        <FilePreview
          file={currentFile}
          {...getFileSizeByMode(mode)}
          isShowTooltip={false}
          className="linked-record-cover-image__preview"
        />
      )}

      {!currentFile && (
        <Icon
          size="S"
          name="image"
          color="currentColor"
          ariaLabel="Linked Record Cover Image Blank"
        />
      )}
    </div>
  );
};
